import { useEffect } from 'react';

export default function InstagramFeedSection() {
  useEffect(() => {
    // Ensure Elfsight platform script is loaded
    const scriptSrc = 'https://elfsightcdn.com/platform.js';
    let script = document.querySelector(`script[src="${scriptSrc}"]`);
    if (!script) {
      script = document.createElement('script');
      script.src = scriptSrc;
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  return (
    <section className="py-16 sm:py-20 bg-stone-50 text-stone-900 border-t border-stone-200 relative overflow-hidden">
      {/* Elfsight Instagram Feed | G28 */}
      <div className="max-w-7xl mx-auto px-4 sm:px-8">
        <div
          className="elfsight-app-2b3215e0-344d-4c6f-aaaf-68bbf665acc3"
          data-elfsight-app-lazy
        />
      </div>
    </section>
  );
}
